import { render } from "./CreateGoalReference.vue?vue&type=template&id=8d0e42da&ts=true"
import script from "./CreateGoalReference.vue?vue&type=script&lang=ts"
export * from "./CreateGoalReference.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__